import request from "@/utils/request";

export default function adminGetNewsMessage(current=1, pageSize=10, params) {
    return request({
        url: `/newsMessage/agencyGetMessages/`+current+`/`+pageSize,
        method: 'get',
        params
    })
}
